export default "__VITE_ASSET__b1e949c3__"